import {Component, HostListener, Input} from "@angular/core";
import {FUIAbstractToggle} from "../abstract-toggle";

@Component({
    selector: "fui-section-toggle",
    styleUrls: ["./section-toggle.component.scss"],
    templateUrl: "./section-toggle.component.html",
    standalone: false
})
export class FUISectionToggleComponent extends FUIAbstractToggle {
    /**
     * Set and emit the toggled value for interested
     * external components
     */
    @HostListener("click")
    public toggle(): void {
        this.toggled = !this.toggled;
        this.toggled$.emit(this.toggled);
    }
}
